import { action, makeObservable } from 'mobx'
import { DirectDepositTaxRefundDeliveryMethod } from '@taxfyle/api-internal/internal/tax_refund_methods_pb'
import BankAccountEditorViewModel from './BankAccountEditorViewModel'

export default class DirectDepositDeliveryMethodEditorViewModel {
  readonly bankAccountVm = new BankAccountEditorViewModel()

  constructor() {
    makeObservable(this)
  }

  @action.bound
  validate() {
    return this.bankAccountVm.validate()
  }

  @action.bound
  reset(method?: DirectDepositTaxRefundDeliveryMethod.AsObject) {
    this.bankAccountVm.reset(method?.bankAccount)
  }
}
